import { AuthProvider, useAuth } from './contexts/AuthContext';
import { TaskCacheProvider } from './contexts/TaskCacheContext';
import { BrandProvider } from './contexts/BrandContext';
import { ToastProvider } from './contexts/ToastContext';
import Login from './components/Login';
import ResetPassword from './components/ResetPassword';
import CRMApp from './components/CRMApp';
import PublicCalculator from './components/PublicCalculator';
import { useEffect, useState } from 'react';

function AppContent() {
  const { user, loading } = useAuth();
  const [isPasswordRecovery, setIsPasswordRecovery] = useState(false);
  const [isPublicShare, setIsPublicShare] = useState(false);

  useEffect(() => {
    const hashParams = new URLSearchParams(window.location.hash.substring(1));
    const type = hashParams.get('type');
    if (type === 'recovery') {
      setIsPasswordRecovery(true);
    }

    const searchParams = new URLSearchParams(window.location.search);
    const estimateId = searchParams.get('estimate') || searchParams.get('testimate');
    const brandId = searchParams.get('brand');
    if (estimateId || brandId) {
      setIsPublicShare(true);
    }
  }, []);

  if (loading && !isPublicShare) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg">Loading...</div>
      </div>
    );
  }

  if (isPublicShare) {
    return <PublicCalculator />;
  }

  if (isPasswordRecovery) {
    return <ResetPassword />;
  }

  if (!user) {
    return <Login />;
  }

  return (
    <BrandProvider>
      <TaskCacheProvider>
        <CRMApp />
      </TaskCacheProvider>
    </BrandProvider>
  );
}

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <AppContent />
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
